import Loading from "components/common/Loading";
import { useVerify } from "hooks/useVerify";
import { Outlet } from "react-router-dom";

const ProtectedRoute = ({ children }: { children?: React.ReactNode }) => {
  const { isLoading } = useVerify();
  if (isLoading) return <Loading height={500} center />;

  return <>{children || <Outlet />}</>;
};

export default ProtectedRoute;
